import { Box, Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useHistory } from 'react-router-dom';
import { Permissions } from '../../../../shared/auth/constants/permissions';
import { useHasPermission } from '../../../Session';
import useCommonStyles from '../../../useCommonStyles';

const SaleTransactionsFooter = () => {
    const commonStyles = useCommonStyles();
    const history = useHistory();
    const canCreate = useHasPermission(Permissions.SALES_TRANSACTION_CREATE);

    if (!canCreate) {
        return null;
    }

    return (
        <Box mt={7}>
            <Box bottom="1rem" position="fixed" right="2rem">
                <Fab
                    classes={{
                        root: commonStyles.fabRoot,
                    }}
                    onClick={() => history.push('/salesTransactions/create')}
                    size="large"
                >
                    <AddIcon />
                </Fab>
            </Box>
        </Box>
    );
};

export default SaleTransactionsFooter;
